(function() {
	'use strict';

	angular.module('trakeyeApp').controller('MobileUserAttendaceController', MobileUserAttendaceController)
	angular.module('trakeyeApp').filter('trustFilter', ['$sce', function($sce) {
		return function(text) {
			return $sce.trustAsHtml(text);
		};
	}]);

	MobileUserAttendaceController.$inject = ['$scope', '$sce', '$state', "Report"];

	function MobileUserAttendaceController($scope, $sce, $state, Report) {
		var vm = this;
		vm.datePickerOpenStatus = {};
		vm.openCalendar = openCalendar;
		vm.downloadAttendenceReport = downloadAttendenceReport;
		vm.report = report;
		vm.reporthide = false;
		vm.select2 = select2;
		var date = "dd EEE";
		vm.today = today();
		vm.userType = "mobileUser";
		vm.selecterange = selectRange;
		vm.sortResponse = sortResponse;

		vm.maxDate = new Date();
		vm.maxDate.setHours(23, 59, 59, 999);

		vm.select2();

		vm.users = loadPage();

		function loadPage() {
			Report.getUsers('', function(response) {
				vm.users = response;
			})
			getPresentDayCheckedInUserSummary();
		}

		function today() {
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function downloadAttendenceReport() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReportDownload({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function(response) {
				var a = document.createElement("a");
				a.style = "display: none";
				var file = new Blob([(response)], { type: 'application/csv' });
				var fileURL = URL.createObjectURL(file);
				// window.open(fileURL, "_blank");
				a.href = fileURL;
				a.download = "user_report.csv";
				a.click();
				window.URL.revokeObjectURL(fileURL);
			});
		}

		function report() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				reportType: vm.userType
			}, function(response) {
				var diffMillis = vm.toTime - vm.fromTime;
				var diffDays = diffMillis / (1000 * 60 * 60 * 24);

				console.log("Days between:", Math.ceil(diffDays));
				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function sortResponse() {
			if (vm.userAgent == 'all') {
				vm.id = 0;
			}
			Report.getAttendenceReport({
				id: vm.id,
				ageType: vm.dateRange,
				fromTime: vm.fromTime,
				toTime: vm.toTime,
				sortFieldName: vm.predicate,
				sortOrder: vm.reverse ? 'asc' : 'desc',
				reportType: vm.userType
			}, function(response) {

				if (response instanceof Array) {
					vm.reportRecords = response;
				} else {
					vm.reportRecords = [];
					vm.reportRecords.push(response);
				}
				vm.search = "";
				vm.reporthide = true;
			})
		}

		function select2() {
			$(".select2").select2();
		}



		vm.datePickerOpenStatus.createdDate = false;
		vm.datePickerOpenStatus.modifiedDate = false;
		vm.datePickerOpenStatus.serviceDate = false;

		function openCalendar(date) {
			vm.datePickerOpenStatus[date] = true;
		}

		vm.calculateToDate = calculateToDate;
		vm.calculateFromDate = calculateFromDate;
		function calculateFromDate() {

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}
		function calculateToDate() {

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

		function selectRange(range) {

			if (range == 'day') {
				var today = new Date();
				vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
				vm.fromDate.setHours(0, 0, 0, 0);
				vm.fromTime = vm.fromDate.getTime();
				vm.toDate.setHours(23, 59, 59, 999);
				vm.toTime = vm.toDate.getTime();

			} else if (range == 'week') {
				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setDate(date.getDate() - 7)
				vm.fromTime = date.getTime();

			} else if (range == 'month') {

				var date = new Date();
				date.setHours(23, 59, 59, 999);
				vm.toTime = date.getTime();
				// date.setHours(0, 0, 0, 0);
				date.setMonth(date.getMonth() - 1);
				vm.fromTime = date.getTime();
			}
		}

		function getPresentDayCheckedInUserSummary() {
			Report.getpresentDayCheckinUserSummary(function(response) {
				vm.summary = response.data;
			})
		}
		function calculateFromDate() {

			if (vm.fromDate > vm.toDate) {
				alert("From Date cannot be greater than To Date");
				vm.fromDate = new Date(vm.toDate);
			}

			vm.fromDate.setHours(0, 0, 0, 0);
			vm.fromTime = vm.fromDate.getTime();
		}

		function calculateToDate() {

			var today = new Date();
			today.setHours(23, 59, 59, 999);

			// Prevent future dates
			if (vm.toDate > today) {
				alert("To Date cannot be a future date");
				vm.toDate = new Date(today);
			}

			// Prevent To Date < From Date
			if (vm.toDate < vm.fromDate) {
				alert("To Date cannot be less than From Date");
				vm.toDate = new Date(vm.fromDate);
			}

			vm.toDate.setHours(23, 59, 59, 999);
			vm.toTime = vm.toDate.getTime();
		}

	}
})();
